import { Link } from "react-router-dom";
import { Avatar, Button, Table } from "flowbite-react";
import { MdVerified } from "react-icons/md";
import DateFormatter from "../dates/DateFormatter";
import { useState } from "react";
import { dismissMessage } from "../../api/messages";
import toast from "react-hot-toast";
import clsx from "clsx";

const NotificationRow = ({ notification }) => {
  const [loading, setLoading] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const handleDismiss = async () => {
    setLoading(true);

    try {
      await dismissMessage(notification._id);

      setDismissed(true);
      
      toast.success('Notification has been dismissed successfully');
    } catch (error) {
      console.error(error);
      toast.error('Failed to dismiss a notification');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Table.Row className={clsx('bg-white', {
      'opacity-50': dismissed,
    })}>
      <Table.Cell>
        <Link
          className="flex gap-4 items-center"
          to={`/campaigns/${notification?.conversationId?.campaignInfluencerId?.campaignId?._id}/${notification?.conversationId?.campaignInfluencerId?._id}`}
        >
          <Avatar img={notification?.conversationId?.campaignInfluencerId?.influencerId?.profile?.picture} rounded />
          <div>
            <div className="text-gray-900 flex gap-1 items-center">
              {notification?.conversationId?.campaignInfluencerId?.influencerId?.profile?.fullname}
              {notification?.conversationId?.campaignInfluencerId?.influencerId?.profile?.isVerified && <MdVerified className="text-blue-500" />}
            </div>
            <div className="text-xs mt-1">@{notification?.conversationId?.campaignInfluencerId?.influencerId?.profile?.username}</div>
          </div>
        </Link>
      </Table.Cell>
      <Table.Cell>
        <DateFormatter
          date={notification.createdAt}
          ago={true}
        />
      </Table.Cell>
      <Table.Cell>
        <Link to={`/campaigns/${notification?.conversationId?.campaignInfluencerId?.campaignId?._id}`}>{notification?.conversationId?.campaignInfluencerId?.campaignId?.name}</Link>
      </Table.Cell>
      <Table.Cell>{notification?.conversationId?.campaignInfluencerId?.status}</Table.Cell>
      <Table.Cell>
        {notification?.role === 'human' ? 'Waiting for human interaction' : 'Managed by AI Agent'}
      </Table.Cell>
      <Table.Cell>
        <Button color="dark" onClick={handleDismiss} isProcessing={loading} disabled={loading || dismissed}>Dismiss</Button>
      </Table.Cell>
    </Table.Row>
  )
}

export default NotificationRow;
